var toString = require('../to-string');

var upperFirst = function upperFirst(value) {
  var str = toString(value);
  return str.charAt(0).toUpperCase() + str.substring(1);
};

module.exports = upperFirst;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/string/upper-first.js
// module id = 64
// module chunks = 0 1 2